import { TAX_EMPTY_VALIDATION, TAX_ERROR, TAX_HIDE_EMPTY_VALIDATION, TAX_HIDE_ERROR, TAX_REPORT, } from "../../interfaces/Reports/iTaxReport";
const initState = {
    data: {
        taxSummary: null,
        taxDetail: [],
    },
    downloadStatus: {
        error: null,
        isOpen: null,
    },
    emailStatus: {
        error: null,
        isOpen: null,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
};
const taxReport = (state = initState, action) => {
    switch (action.type) {
        case TAX_REPORT:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case TAX_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case TAX_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initState[action.errorType] });
        case TAX_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case TAX_HIDE_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: initState.emptyValidation });
        default:
            return Object.assign({}, state);
    }
};
export default taxReport;
